import styled from 'styled-components';

export const Container = styled.div``;

export const LinkTitle = styled.div`
  font: 500 16px/19px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.$secondary};
  cursor: pointer;
`;
